<div class="inactive-integration">
  <app-popup-top-line></app-popup-top-line>
  <div class="inactive-integration-header">
    <div class="title">Inactive integration</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="inactive-integration-body">
    <div class="inactive-integration-body-text">
      <div class="constant-text">
        The integration {{ integrationData.name }} is inactive, for changes to take effect please activate it.
      </div>
    </div>
  </div>
  <div class="inactive-integration-footer">
    <button class="confirm" (click)="onClose()">OK</button>
  </div>
</div>
